import { Component } from '@angular/core';
import { OttoOlsenOrderCardListComponent } from '../otto-olsen-order-card-list/otto-olsen-order-card-list.component';

@Component({
  selector: 'otto-olsen-order-mobile-card-list',
  templateUrl: './otto-olsen-order-mobile-card-list.component.html',
  styleUrls: ['./otto-olsen-order-mobile-card-list.component.scss'],
  standalone: false
})
export class OttoOlsenOrderMobileCardListComponent extends OttoOlsenOrderCardListComponent { }
